import script from "./VCollapse.vue?vue&type=script&lang=ts&setup=true"
export * from "./VCollapse.vue?vue&type=script&lang=ts&setup=true"

import "./VCollapse.vue?vue&type=style&index=0&id=31259b1b&lang=sass"

const __exports__ = script;

export default __exports__